import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';
import { useOrdersCreateCalculatorStore, useOrdersCreateDataPreparedStore } from '@/apps/order/stores/ordersCreate';
import DataPreparedAddressInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedAddressInterface';
import BillingTypesParamsInterface from '@/apps/order/interfaces/ordersCreate/BillingTypesParamsInterface';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

// Never cached: payload carries brand orderProcess flags, so it must be fresh.

const hasDataPreparedStepAddress = async (): Promise<void> => new Promise<void>(
  (resolve, reject) => {
    nextTick(async () => {
      try {
        const dataPreparedStore = useOrdersCreateDataPreparedStore();
        const { dataAddress } = storeToRefs(dataPreparedStore);

        const dataCalculatorPreparedStore = useOrdersCreateCalculatorStore();
        const { formData } = storeToRefs(dataCalculatorPreparedStore);

        const params: DataPreparedParamsInterface = {};
        if (formData.value.salesPartnerNumber) {
          params.salesPartnerNumber = formData.value.salesPartnerNumber;
        }

        if (formData.value.brand_id) {
          params.brand_id = formData.value.brand_id;
        }

        // Merge, never replace: billingTypes live on this store too and a replace dropped
        // them (357ac87ab). A failed refetch must not eject the user from a loaded step.
        await OrderAPI.fetchDataPreparedStepAddress(params)
          .then((data) => {
            dataAddress.value = { ...dataAddress.value, ...data } as DataPreparedAddressInterface;
          })
          .catch((e) => {
            if (dataAddress.value === undefined) throw e;
          });

        /* eslint-disable camelcase */
        const { brand_id, sales_channel_id } = formData.value;
        if (
          brand_id !== undefined
          && sales_channel_id !== undefined
        ) {
          const billingParams: BillingTypesParamsInterface = {
            brand_id,
            sales_channel_id,
          };

          if (formData.value.salesPartnerNumber) {
            billingParams.salesPartnerNumber = formData.value.salesPartnerNumber;
          }

          // Refetched per entry too: the merge above keeps the previous brand's billingTypes,
          // so only a refetch corrects them after a brand switch. Same failure rule as above.
          await OrderAPI.fetchBillingTypes(billingParams)
            .then((billingTypes) => {
              dataAddress.value = {
                ...dataAddress.value,
                billingTypes,
              } as DataPreparedAddressInterface;
            })
            .catch((e) => {
              if (dataAddress.value?.billingTypes === undefined) throw e;
            });
        }
        /* eslint-enable camelcase */

        resolve();
      } catch (e) {
        reject(e);
      }
    });
  },
);

export default hasDataPreparedStepAddress;
